__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-benefits-activity'].baseUrl;
import ModuleContainer from './components/AxpBenefitsActivity';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/data-manager-utils': '^0.4.2',
      '@americanexpress/product-ducks': '^1.3.3'
    }
  });
}